'use client';

import { ReactNode } from 'react';
import { isFeatureEnabled, FeatureFlag } from '@/lib/features';

export default function FeatureGate({
  feature,
  children,
  fallback = null,
}: {
  feature: FeatureFlag;
  children: ReactNode;
  fallback?: ReactNode;
}) {
  if (!isFeatureEnabled(feature)) {
    return <>{fallback}</>;
  }
  return <>{children}</>;
}